/**
 * @file        src/components/TableSkeleton.jsx
 * @description Loading placeholder rows for list views.
 * @author      Kinetika Labs
 * @created     2026-06-22
 * @changelog
 *   - 2026-06-22 Claude — Initial.
 */
export default function TableSkeleton({ rows = 6 }) {
  return (
    <div aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="skeleton sk-row" />
      ))}
    </div>
  );
}
